import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=47983ac3&"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=47983ac3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports